// extracted by mini-css-extract-plugin
var _1 = "CLlnPx2vQ5TK92cyE_Yy";
var _2 = "WzBKkH2OyojfjUIovXwC";
var _3 = "pgKPiq63bHKO5RVJ7nlN";
var _4 = "U5ncVjnN_6zMjNVMR592";
export { _1 as "col", _2 as "logo", _3 as "mainContainerWrapper", _4 as "signInPage" }
